'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { isLocale, persistLocalePreference } from '@/lib/localePreference';

// Se l'utente atterra su un URL con prefisso locale ESPLICITO (/it, /fr, ...),
// salva quella lingua come preferenza (localStorage + cookie NEXT_LOCALE):
// cosi' dopo signup/login (redirect Clerk a /app/... senza prefisso) l'app
// riparte nella lingua giusta. Il default (en, URL nudi) non sovrascrive nulla.
export function LocaleSync() {
  const pathname = usePathname();
  useEffect(() => {
    const first = (pathname ?? window.location.pathname).split('/')[1];
    if (isLocale(first)) persistLocalePreference(first);
  }, [pathname]);
  return null;
}
